export default __webpack_public_path__ + "static/media/nublado.b689d982.png";